import React from 'react';

import Features from 'components/Features';

import illu_api from './images/api.svg';
import illu_competitive_advantage from './images/competitive_advantage.svg';
import illu_easy_implementation from './images/easy_implementation.svg';
import illu_less_returns from './images/less_returns.svg';
import illu_low_costs from './images/low_costs.svg';
import illu_marketing from './images/marketing.svg';
import illu_more_orders from './images/more_orders.svg';
import illu_personalization from './images/personalization.svg';
import illu_service_and_support from './images/service_and_support.svg';
import illu_size_charts from './images/size_charts.svg';
import illu_trends from './images/trends.svg';
import illu_users from './images/users.svg';

const ILLUSTRATIONS = {
  api: illu_api,
  competitive_advantage: illu_competitive_advantage,
  easy_implementation: illu_easy_implementation,
  less_returns: illu_less_returns,
  low_costs: illu_low_costs,
  marketing: illu_marketing,
  more_orders: illu_more_orders,
  personalization: illu_personalization,
  service_and_support: illu_service_and_support,
  size_charts: illu_size_charts,
  trends: illu_trends,
  users: illu_users,
};

export default (keys: Array<string>): JSX.Element => (
  <Features
    base="business.index.benefits.features"
    keys={keys}
    illustrations={ILLUSTRATIONS}
    imageSize={60}
  />
);
